import closeMenu from '@/_components/menu/close'
import trapFocus from '@root/assets/ts/_components/menu/trapFocus'
import focusableElementsString from '@/_utils/focusableElementsString'

/**
 * Opens the modal and traps focus.
 */
const open = (
  focusedElementBeforeMenu: HTMLElement|null,
  menuOverlay: HTMLElement,
  menuToggle: HTMLElement,
  menuToOpen: string
) => {

  const mobileMenu = document.querySelector<HTMLElement>( `[data-menu="${menuToOpen}"]` )

  if ( ! mobileMenu || ! menuOverlay ) return false

  const close = () => closeMenu( focusedElementBeforeMenu, mobileMenu, menuOverlay, menuToggle )

  // Save current focus.
  focusedElementBeforeMenu = document.activeElement as HTMLElement

  // Listen for indicators to close the modal.
  menuOverlay.addEventListener( 'click', () => close )

  // Modal close buttons.
  const closeButtons = mobileMenu.querySelectorAll( '[data-close-menu]' )

  // Attach listeners to all the close modal buttons.
  closeButtons.forEach( closeButton => closeButton.addEventListener( 'click', () => close() ) )

  // Find all focusable children.
  const focusableElements = mobileMenu.querySelectorAll( focusableElementsString )
  const firstTabStop = focusableElements[0] as HTMLElement
  const lastTabStop = focusableElements[focusableElements.length - 1] as HTMLElement

  mobileMenu.addEventListener( 'keydown', ( e: KeyboardEvent ) => trapFocus( e, firstTabStop, lastTabStop, close ) )

  menuToggle.setAttribute( 'aria-expanded', 'true' )
  mobileMenu.setAttribute( 'data-menu-closed', 'false' )
  mobileMenu.setAttribute( 'aria-hidden', 'false' )

  // This just allows for the animation, not required.
  setTimeout( () => mobileMenu.classList.remove( 'is-closed' ), 10 )

  // Focus first child
  firstTabStop.focus()

  return true

}

export default open
